// F-O — global AI narration usage meter (`GET /api/staff/ai-usage`).
//
// Read-only: one meter for the whole system, keyed to the current HKT
// calendar month. `budgetChars` is the EFFECTIVE budget (standing .env
// value + this month's dev-team top-up grants); the FE derives
// percentage / remaining. No self-serve mutation exists on the wire —
// top-ups are CLI-only (`python -m app.cli.ai_budget`).

import { getApiClient } from "./client";

export interface AiUsage {
  month: string; // "YYYY-MM", HKT calendar month
  usedChars: number;
  budgetChars: number;
  blocked: boolean;
  /** F-V: false when an admin switched AI narration off (vs budget used up). */
  generationEnabled?: boolean;
}

export async function getAiUsage(): Promise<AiUsage> {
  const { data } = await getApiClient().get<AiUsage>("/staff/ai-usage");
  return data;
}
